export enum StockStatus {
  'InStock' = 'IN_STOCK',
  'NoStock' = 'NO_STOCK',
  'PartialStock' = 'PARTIAL_STOCK',
}
